import React, { useState, useEffect, Fragment } from 'react';

import { ToastTypes, withToast } from '../contexts/toastr.context';
import { useDyteClient } from '@dytesdk/react-web-core';
import { DyteMeeting } from '@dytesdk/react-ui-kit';
import { useParams } from 'react-router-dom';
import { AuthService } from '../_service/auth.service';

// 824c8433-cff8-4bac-be74-891d5ceae118
export const USER_MEETING_ROUTE = '/join-session/user/:uuid';

const UserMeetingPageComponent = ({ addToast, history }) => {
    const [dyteMeeting, initMeeting] = useDyteClient();
    const { uuid } = useParams();

    if (!uuid) {
        history.push('/');
    }

    useEffect(() => {
        if (uuid) {
            AuthService.getMeeingUniqData(uuid)
                .then((response) => {
                    console.log('response', response);
                    const meetingObj = {
                        roomName: `${response.roomName}`,
                        authToken: `${response.authToken}`,
                        defaults: {
                            audio: false,
                            video: false,
                        },
                    };
                    initMeeting(meetingObj);
                })
                .catch((error) => {
                    if (
                        error &&
                        error.response &&
                        error.response.data.message
                    ) {
                        addToast(
                            error.response.data.message,
                            '',
                            ToastTypes.danger
                        );
                        history.push('/');
                    }
                });
        }
    }, []);

    useEffect(() => {
        if (dyteMeeting) {
            dyteMeeting.meta.on('disconnected', () => {
                window.close();
            });
        }
    }, [dyteMeeting]);

    return (
        <div
            className=""
            style={{
                height: '100vh',
                backgroundColor: '#f4f6fe',
            }}>
            <DyteMeeting meeting={dyteMeeting} mode="fill" />
        </div>
    );
};

const UserMeetingPage = withToast(UserMeetingPageComponent);

export default UserMeetingPage;
